import { useQuery } from '@tanstack/react-query';
import { fetchAdminCategories } from '../api/settingsApi';
import { CATEGORY_TARGET } from './useCategories';

// All categories (including inactive) for the settings admin screen.
// Uses a separate queryKey from useCategories so mutations can invalidate
// both the dropdown cache and the admin list independently.
export default function useAdminCategories(targetType) {
    return useQuery({
        queryKey: ['adminCategories', targetType],
        queryFn:  () => fetchAdminCategories(targetType),
        staleTime: 0, // always fresh for the admin screen
        enabled: targetType === CATEGORY_TARGET.Expense
              || targetType === CATEGORY_TARGET.Invoice,
    });
}
